import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {useGetOneNomenclaturesTemplatesCategory} from '@/modules/settings/hooks/useNomenclaturesTemplatesCategory';
const UserRegistersAccessCategoryCell = ({entity}) => {
  const {data} = useGetOneNomenclaturesTemplatesCategory({id: entity?.category});
  return (
    // <Link to={`${ROUTE_PATH_NOMENCLATURES_SERVICES_CATEGORY}/${entity._id}`}>
    <div className={'flex flex-row'}>
      <div className={'flex flex-col justify-center'}>
        <span className={
          'font-medium lg:font-normal ' +
            'mb-1 lg:mb-0'
            // 'text-lg lg:text-base text-black lg:text-primary'
        }>
          {data?.data?.name}
        </span>
      </div>
    </div>
    // </Link>
  );
};

UserRegistersAccessCategoryCell.propTypes = {
  entity: PropTypes.object,
};
UserRegistersAccessCategoryCell.defaultProps = {
  entity: {},
};

export default memo(UserRegistersAccessCategoryCell);


/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderUserRegistersAccessCategoryCell = (text, entity) => {
  return (
    <UserRegistersAccessCategoryCell entity={entity}/>
  );
};

